import { configureStore } from '@reduxjs/toolkit';
import AppReducer from 'app/slice/appSlice';

export const store = configureStore({
  reducer: {
    app: AppReducer,
  },
});
